<template>
  <div>
    <oplata-form></oplata-form>
  </div>
</template>
<script>
import OplataForm from "../Oplata/Update.vue";
export default {
  components: {
    OplataForm
  }
};
</script>
